/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_FailedInputs */

const en_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save failed`)
};

const es_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al guardar`)
};

const fr_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'enregistrement`)
};

const de_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen`)
};

const ja_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存に失敗しました`)
};

const zh_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存失败`)
};

const ar_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل الحفظ`)
};

const id_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyimpan`)
};

const it_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio non riuscito`)
};

const ru_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось сохранить`)
};

const pt_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao salvar`)
};

const ko_save_failed = /** @type {(inputs: Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장 실패`)
};

/**
* | output |
* | --- |
* | "Save failed" |
*
* @param {Save_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_failed = /** @type {((inputs?: Save_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_failed(inputs)
	if (locale === "es") return es_save_failed(inputs)
	if (locale === "fr") return fr_save_failed(inputs)
	if (locale === "de") return de_save_failed(inputs)
	if (locale === "ja") return ja_save_failed(inputs)
	if (locale === "zh") return zh_save_failed(inputs)
	if (locale === "ar") return ar_save_failed(inputs)
	if (locale === "id") return id_save_failed(inputs)
	if (locale === "it") return it_save_failed(inputs)
	if (locale === "ru") return ru_save_failed(inputs)
	if (locale === "pt") return pt_save_failed(inputs)
	return ko_save_failed(inputs)
});